(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["serray-tiktok-videos"] && !Shopify.designMode) return;
  try {
    function parseSerrayTikTokURL(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['www.tiktok.com', 'tiktok.com'].includes(url.hostname) || url.username || url.password) return null;
    const match = url.pathname.match(/^\/(?:@[^/]+\/video|player\/v1|embed\/v2|embed)\/(\d{10,25})\/?$/);
    return match ? { id: match[1], source: url.href } : null;
  } catch { return null; }
}
if (!customElements.get('serray-tiktok-videos')) {
  customElements.define('serray-tiktok-videos', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.s-tiktok-track');
      this.cards = [...this.querySelectorAll('.s-tiktok-card')];
      this.current = 0;
      this.previous = this.querySelector('[data-video-previous]');
      this.next = this.querySelector('[data-video-next]');
      this.counter = this.querySelector('[data-current-video]');
      this.querySelector('.s-tiktok-navigation')?.removeAttribute('hidden');
      this.previous?.addEventListener('click', () => this.go(this.current - 1), { signal });
      this.next?.addEventListener('click', () => this.go(this.current + 1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !matchMedia('(max-width:760px)').matches) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }, { signal, passive:true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.loader = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { this.load(entry.target); this.loader.unobserve(entry.target); }
      }), { rootMargin:'160px' });
      this.cards.filter(card => card.dataset.tiktokUrl).forEach(card => this.loader.observe(card));
      window.addEventListener('message', event => {
        if (!['https://www.tiktok.com', 'https://tiktok.com'].includes(event.origin) || !event.data || event.data['x-tiktok-player'] !== true) return;
        const source = this.cards.find(card => card.querySelector('iframe')?.contentWindow === event.source);
        if (!source) return;
        if (event.data.type === 'onStateChange' && event.data.value === 1) this.cards.filter(card => card !== source).forEach(card => this.pause(card));
        if (event.data.type === 'onPlayerError' || event.data.type === 'onError') this.showError(source);
      }, { signal });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.loader?.disconnect(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
    load(card) {
      const video = parseSerrayTikTokURL(card.dataset.tiktokUrl);
      if (!video) { const source = card.querySelector('.s-tiktok-source'); if (source) { source.hidden = true; source.removeAttribute('href'); } this.showError(card, true); return; }
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.tiktok.com/player/v1/' + video.id + '?autoplay=0&controls=1&description=0&music_info=0&rel=0&closed_caption=1';
      iframe.title = card.dataset.videoTitle;
      iframe.allow = 'fullscreen';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.addEventListener('load', () => { card.querySelector('.s-tiktok-state').hidden = true; }, { signal:this.abort.signal });
      card.querySelector('.s-tiktok-media').append(iframe);
    }
    showError(card, unsupported = false) { card.querySelector('iframe')?.remove(); const state = card.querySelector('.s-tiktok-state'); state.hidden = false; state.querySelector('p').textContent = unsupported ? card.dataset.videoInvalid : card.dataset.videoError; }
    pause(card) { card.querySelector('iframe')?.contentWindow.postMessage({ 'x-tiktok-player':true, type:'pause' }, 'https://www.tiktok.com'); }
    go(index) {
      const target = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!target) return;
      this.track.scrollTo({ left:target.offsetLeft - this.cards[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      const nearest = this.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? index : best, 0);
      if (nearest !== this.current && matchMedia('(max-width:760px)').matches) this.pause(this.cards[this.current]);
      this.current = nearest;
      if (this.counter) this.counter.textContent = String(nearest + 1);
      if (this.previous) this.previous.disabled = nearest === 0;
      if (this.next) this.next.disabled = nearest === this.cards.length - 1;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
